<template>
<div class="container-fluid">
    <div class="row center-xs">
        <div class="col-sm-8 col-xs-12">
          <div class="form-container">
            <form id="currentProjectForm" name="currentProjectForm">
              
                <div class="form__wrapper">
                    <input class="form__input" type="text" name="projectCover" v-model="currentProject.cover" required> 
                    <label class="form__label" for="projectCover">Project cover</label>
                </div>
                
                <div class="form__wrapper">
                    <input class="form__input" type="text" name="projectCover" v-model="currentProject.photoCredit"> 
                    <label class="form__label" for="projectCover">Photo credits</label>
                </div>

                <div class="form__wrapper">
                    <input class="form__input" type="text" name="projectTitle" v-model="currentProject.title" required>
                    <label class="form__label" for="projectTitle">Project title</label>                  
                </div>

                <div class="form__wrapper">
                    <input class="form__input" type="text" name="projectYear" v-model="currentProject.year">
                    <label class="form__label" for="projectYear">Project year</label>
                </div>

                <div class="form__wrapper">
                    <input class="form__input" type="text" name="projectType" v-model="currentProject.type">
                    <label class="form__label" for="projectType">Project type</label>          
                </div>

                <div class="form__wrapper-textarea">
                    <textarea class="form__input-textarea" type="text" 
                    rows="6"
                    name="projectDescription" 
                    placeholder="Project description" 
                    v-model="currentProject.description" 
                    required>
                    </textarea> 
                    <label class="form__label-textarea" for="projectDescription">Project description</label>     
                    <span class="markdown-supported"><small><a href="https://en.wikipedia.org/wiki/Markdown">Markdown</a> supported</small></span>
                </div> 

                <div class="add-img-container">
                  <button type="button" class="btn btn-outline" @click="addImage">
                      ADD IMAGE
                  </button>   
                </div>
            
                <div class="form__wrapper" v-for="(image, index) in currentProject.images" v-bind:key="index">
                    <input class="form__input img-url-input" type="text" v-model="image.url" :key="index">
                    <label class="form__label" for="input">Image URL</label>
                    <a class="remove-field-link" href="javascript:void(0)" @click="removeField(index)"><delete-icon :size="24"></delete-icon></a>
                </div>    

                <div class="form-error" v-if="errorMsg">
                  <alert-circle-icon></alert-circle-icon> {{errorMsg}} 
                </div>

                <div class="form__wrapper--submit">
                  <div class="form-input--submit">
                    <button type="button" :disabled="!isFormValid" class="btn btn-block" @click="saveProject(currentProject)"><span>
                      <span v-if="editingProject">UPDATE</span> 
                      <span v-if="!editingProject">ADD</span>
                      PROJECT
                      </span>
                    </button>
                  </div>
                </div>  

            </form>
          </div>
        </div>
    </div>
</div>
</template>

<script>
import { ProjectsService } from "@/services/ApiService.js";
import { EventBus } from '@/services/EventBus.js';
import AlertCircleIcon from 'vue-material-design-icons/AlertCircle.vue';
import DeleteIcon from 'vue-material-design-icons/Delete.vue';

export default {
    name: 'ProjectForm',
    components: {
      AlertCircleIcon,
      DeleteIcon
    },
    props: {
      project: Object
    },
    data() {
        return {
            currentProject: {
            title: '',
            year: '',
            description: '',
            cover: '',
            photoCredit: '',
            images: []
          },
          errorMsg: ''         
        }
    },
    created: function () {
      if (this.project) {
        this.currentProject = this.project;
      }
    },
    methods: {
      saveProject(project) {
        if (!this.editingProject) {
          ProjectsService.addProject(project).then(() => {
            this.clearForm();
            EventBus.$emit('projectModifyEvent');
          }).catch(err => {
            this.errorMsg = err;
          });
        } else {
          ProjectsService.updateProject(this.project._id, project).then(() => {
            this.clearForm();
            EventBus.$emit('projectModifyEvent');
          }).catch(err => {
            this.errorMsg = err;
          });
        }
      }, 
      addImage() {
        this.currentProject.images.push({ url: '' });
      },
      clearForm() {
        this.currentProject = {title: '', year: '', photoCredit: '', description: '', cover: '', images:[]};
      },
      removeField(index) {
        this.currentProject.images.splice(index, 1);
      }
    },
    computed: {
      editingProject: function () {
        return this.project._id
      },
      isFormValid: function () {
        return this.currentProject.title.length > 0 && this.currentProject.description.length > 0 && this.currentProject.cover.length > 0
      }
    }
}
</script>

<style lang="less" scoped>
.markdown-supported {
  display: block;
  color: #343434;
  text-align: left;
  opacity: 0.83;
}
.img-url-input {
  width: 90%;
  display: inline-block;
}
.remove-field-link {
  display: inline-block;
  color: crimson;
  margin-left: 10px;
  cursor: pointer;
  text-decoration: none;
}
.form-error {
  margin-top: 20px;
  color: crimson;
}
.add-img-container {
  text-align: right;
  margin-top: 20px;
}
</style>